import { colors } from '../constants/colors';

// ÐÐ¾Ð»Ð¶ÐµÐ½ ÑÐ¾Ð²Ð¿Ð°Ð´Ð°ÑÑ Ñ LeadStatus.ManagerAssigned Ð½Ð° Ð±ÑÐºÐµ (Crm/Leads/Models/LeadStatus.cs).
export const LEAD_STATUS_MANAGER_ASSIGNED = 1;

/**
 * Ð¤Ð¾Ð½ ÑÑÑÐ¾ÐºÐ¸ Ð² ÑÐ¿Ð¸ÑÐºÐµ Ð»Ð¸Ð´Ð¾Ð² â Ð¿Ð¾ ÑÐ¾Ð¼Ñ, ÑÑÐ¾ Ñ Ð»Ð¸Ð´Ð¾Ð¼ Ð½ÑÐ¶Ð½Ð¾ ÑÐ´ÐµÐ»Ð°ÑÑ.
 *
 * Ð Ð¾Ð·Ð¾Ð²ÑÐ¹ â Ð¾ÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð½ÐµÑ, Ð»Ð¸Ð´ Ð½Ð¸ÐºÑÐ¾ Ð½Ðµ Ð¿ÑÐ¸Ð½ÑÐ» (ÐºÐ½Ð¾Ð¿ÐºÐ° Â«ÐÑÐ¸Ð½ÑÑÑÂ»).
 * ÐÐµÐ¶ÐµÐ²ÑÐ¹ â Ð¿ÑÐ¸Ð½ÑÑ, Ð½Ð¾ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÐµÑÑ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ ÑÐ´ÐµÐ»Ð°Ð»: ÑÑÐ°ÑÑÑ Ð¾ÑÑÐ°Ð»ÑÑ Â«ÐÐ°Ð·Ð½Ð°ÑÐµÐ½
 * Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÂ», ÑÐ´ÐµÐ»ÐºÐ¸ Ð½ÐµÑ. ÐÐµÐ· ÑÐ²ÐµÑÐ° â Ð»Ð¸Ð´ Ð² ÑÐ°Ð±Ð¾ÑÐµ Ð¸Ð»Ð¸ Ð·Ð°ÐºÑÑÑ.
 * undefined â Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð½Ð¸ Ð¿ÑÐ¸ ÑÑÐ¼, Ð´Ð°Ð»ÑÑÐµ ÑÐµÑÐ°ÐµÑ Ð¾Ð±ÑÐ°Ñ ÑÐ°ÑÐºÑÐ°ÑÐºÐ° ÑÐ°Ð±Ð»Ð¸ÑÑ.
 */
const leadRowColor = (lead) => {
  if (!lead?.manager) return colors.rowRedBG;
  if (lead.status?.id === LEAD_STATUS_MANAGER_ASSIGNED && !lead.dealStatus) return colors.rowYellowBG;
  return undefined;
};

export default leadRowColor;
